import { Text } from "@mantine/core";
import { useNavigate } from "react-router-dom";
import { JasperWordmark } from "@jasper/forms";
import packageJson from "../../../package.json";

export const NavbarHeader = () => {
  const navigate = useNavigate();

  return (
    <div
      style={{
        paddingBottom: "5px",
        paddingLeft: "10px",
      }}
    >
      <button
        onClick={() => navigate("/home")}
        style={{
          cursor: "pointer",
          marginBottom: "4px",
          marginLeft: "-2px",
          border: "none",
          background: "none",
          padding: 0,
        }}
        aria-label="Go to home"
      >
        <JasperWordmark size={35} style={{ display: "block" }} />
      </button>
      <div style={{ color: "lightgrey" }}>
        <Text
          size="xs"
          style={{ textAlign: "center", margin: 0, marginLeft: "-2px" }}
        >
          v{packageJson.version}
        </Text>
      </div>
    </div>
  );
};
